import { render, staticRenderFns } from "./Smoking.vue?vue&type=template&id=5d7c4a08&scoped=true&"
import script from "./Smoking.vue?vue&type=script&lang=js&"
export * from "./Smoking.vue?vue&type=script&lang=js&"
import style0 from "./Smoking.vue?vue&type=style&index=0&id=5d7c4a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c4a08",
  null
  
)

export default component.exports